// import React, { useState } from "react";
// import ReactCrop from 'react-image-crop'
// import 'react-image-crop/dist/ReactCrop.css'

// import { useRef } from "react";

// Dialog

// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';

// export default function CropImage() {

//   const [image, setImage] = useState(null)
//   const [crop, setCrop] = useState({  width: 300, height: 169, unit: 'px' })
//   const imageRef = useRef(null);

//   const [output, setOutput] = useState('')

//   const handleImageChanged = (event) => {
//     setImage(URL.createObjectURL(event.target.files[0]))
//   }

//   Dialog
//   const [open, setOpen] = React.useState(false);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setImage(false);
//     setCrop(false);
//     setOutput(false);
//   };


//   function handleDownload() {
//     if (imageRef.current && crop.width && crop.height) {
//       const canvas = document.createElement('canvas');
//       const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
//       const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
//       canvas.width = crop.width;
//       canvas.height = crop.height;
//       const ctx = canvas.getContext('2d');

//       ctx.drawImage(
//         imageRef.current,
//         crop.x * scaleX,
//         crop.y * scaleY,
//         crop.width * scaleX,
//         crop.height * scaleY,
//         0,
//         0,
//         crop.width,
//         crop.height
//       );

//       const croppedImageUrl = canvas.toDataURL('image/png');
//       setOutput(croppedImageUrl)
//     }
//   }


//   return (
//     <div>
//       <div className="m-5" >
//         <input type='file' accept="image/*" ref={imageRef} onChange={handleImageChanged} />
//       </div>

//       <div className="w-6/12 mx-auto">
//         {
//           image &&
//           <ReactCrop aspect={16 / 9}
//             onImageLoaded={setImage}
//             crop={
//               crop
//             }
//             onChange={(c) => setCrop(c)}

//             className=" "
//           >
//             <img src={image} ref={imageRef} className="w-full h-full" alt="r" />
//           </ReactCrop>
//         }
//         <div>
//           <button onClick={handleDownload}>
//             OK
//           </button>
//         </div>
//         <img src={output} alt="Original" />

//       </div>



//       <div>
//       <Button variant="outlined" onClick={handleClickOpen}>
//         Choose Our Family Profile
//       </Button>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//       >
//         <DialogTitle id="alert-dialog-title">
//           {"Use Google's location service?"}
//         </DialogTitle>
//         <DialogContent>

//       <div className="m-5" >
//         <input type='file' accept="image/*" ref={imageRef} onChange={handleImageChanged} />
//       </div>

//       <div className="w-6/12 mx-auto">
//         {
//           image &&
//           <ReactCrop aspect={16 / 9}
//             onImageLoaded={setImage}
//             crop={
//               crop
//             }
//             onChange={(c) => setCrop(c)}

//             className=" "
//           >
//             <img src={image} ref={imageRef} className="w-full h-full" alt="r" />
//           </ReactCrop>
//         }
//         <div>
//           <button onClick={handleDownload} className="bg-[#5c33ae] p-2 text-sm text-white rounded mb-3 hover:bg-[#2f0e70] " >
//             Preview
//           </button>
//         </div>
//         <img src={output} alt="Original" />

//       </div>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose}>Close</Button>
//           <Button onClick={handleClose} autoFocus>
//             Submit
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>


//     </div>

//   )
// }



// import React, { useState } from 'react';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';

// export default function CropImage() {
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0, width: 100, height: 100 });

//   function handleImageUpload(event) {
//     const image = event.target.files[0];
//     setSelectedImage(URL.createObjectURL(image));
//     console.log(URL.createObjectURL(image))
//   }

//   function handleCropComplete(crop) {
//     console.log(crop);
//   }

//   return (
//     <div>
//       <input type="file" accept="image/*" onChange={handleImageUpload} />
//       {selectedImage && (
//         <div>
//           <ReactCrop aspect={16/9} src={selectedImage} crop={crop} onComplete={handleCropComplete} onChange={setCrop} />
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, createRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

// Dialog

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export default function CropImage() {
  const [image, setImage] = useState();
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef();

  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } 
    else 
    if(e.target) {
      files = e.target.files;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };


  //   Dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setImage('');
    setCropData('')
  };

  const handleImageSubmit = () => {
    console.log("Data:", cropData)
  }

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        Choose Our Family Profile
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogContent>
          <div>
            <div style={{ width: "100%" }}>

              <input type="file"  onChange={onChange} className="mb-5" />

              <Cropper
                ref={cropperRef}
                aspectRatio={16 / 9}
                preview=".img-preview"
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                checkOrientation={false}
                guides={true}
              />
            </div>

            <div className="flex mt-3" >

              <div className="w-[50%]" >
                <h1>Preview</h1>
                <div className="img-preview overflow-hidden w-full aspect-[1/1]" />
              </div>

              <div style={{ width: "50%", height: "300px" }} >

                <button
                  className="bg-[#5c33ae] p-2 text-sm text-white rounded mb-3 hover:bg-[#2f0e70] "
                  onClick={getCropData}>
                  Crop Image
                </button>

                {cropData ? <img style={{ width: "100%" }} src={cropData} alt="cropped" /> : null}
              </div>

            </div>

          </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button onClick={handleImageSubmit} autoFocus>Submit</Button>
        </DialogActions>
      </Dialog>
    </div>

)};

